import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
// import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { red } from '@mui/material/colors';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

function MobileCreateDiscussionForum() {
  const navigate = useNavigate();
  const initialValues = {
    discussion_title: "",
    description: "",
  };

  const validationSchema = Yup.object({
    discussion_title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);
  return (
    <div className='MainView'> 
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileDiscussionForum")}
        />
        <h1>New Discussion</h1>
    </div>
    <div className='topSpace'></div>
    <div className='mainWrapperListView'>
    <div className="famDetailsListInrMob">
      <div className='margInline15'>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
      {(formik) => (
        <Form>
        <div className='FormView'>
          <div className='lebalInputView'>
          <FormikControl
            control="input"
            type="text"
            label="Discussion Title"
            placeholder="Enter discussion title"
            labelclassName="inputLebal"
            name="discussion_title"
            className="titleInput"
          />
          </div>
          <div className='lebalInputView'>
          <FormikControl
            control="textarea"
            type="text"
            label="Description"
            placeholder="Enter description"
            labelclassName="inputLebal"
            name="description"
            className="textAreaInput"
          />
          </div>
          <div className='attchmentView'>
            <AttachmentIcon sx={{ fontSize: 30, color: '#3853ec' }} />
            <input type='file' className='fileUploadButton'/>
            <p className='checkBoxTxt'>Attachment</p>
          </div>
          <div className='attchmentView'>
            <p className='fileName'>File name</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
          </div>
          <div className='radioBtnTxtView margineTopAdd'>
          <p className='inputLebal'>Visible to</p>
            <div className="famDetailsListTo">
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>All Member</p>
            </div>
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Owner's</p>
            </div>
            </div>
            <div className="famDetailsListTo">
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Committee Member's</p>
            </div>
            <div className='checkBoxView widthFifty'>
              <input type='radio' className='checkBoxStyle' />
              <p className='checkBoxTxt'>Group's</p>
            </div>
            </div>
            </div>
        <div className='margineTopAdd'>
          <button className='submitButton' type='submit'>Create Discussion</button>
        </div>
        </div>
      </Form>
      )}
      </Formik>
      </div>
    </div>
    </div>
    </div>
  )
}

export default MobileCreateDiscussionForum